import { useSelector } from 'react-redux'
import { UserRole } from '@feedyou/utils'

import { userPermissionsSelector } from '../selectors'

export const useUserRole = (): UserRole => {
  return useSelector(userPermissionsSelector).role
}
